<div class="">
  <div class="d-flex justify-content-between align-items-center">
    <span class="fs-14 font-weight-700">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.ARCHIVES' | translate }}</span>
    <button class="v-btn btn btn-primary-outline vsight-button-outline-primary" (click)="refreshArchives()" [disabled]="!pendingExists || refreshing">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.REFRESH' | translate | uppercase }}</button>
  </div>
  <div class="card-body px-0 py-1 mt-4">
    @if (archives && showArchives) {
      @if (archives.length !== 0) {
        <div class="t-container t-no-hover container-fluid ps-0">
          <div class="t-head row sm-hide pl-3">
            <!-- <div class="t-cell col-1">#</div> -->
            <div class="t-cell col-3 fs-14 text-dark-grey">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.CREATED_AT' | translate }} ({{ timezone }})</div>
            <div class="t-cell col-2 text-lg-center fs-14 text-dark-grey">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.SIZE' | translate }}</div>
            <div class="t-cell col-2 text-lg-center fs-14 text-dark-grey">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.STORAGE' | translate }}</div>
            <div class="t-cell col-2 fs-14 text-dark-grey">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.STATUS' | translate }}</div>
            <div class="t-cell col-3 fs-14 text-dark-grey"></div>
          </div>
          @for (archive of archives; track archive; let i = $index) {
            <div class="t-row row mt-3">
              <!-- <div class="t-cell col-1 sm-hide">{{ i+1 }}</div> -->
              <!-- <div class="t-cell sm-show col-6">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.CREATED_AT' | translate }} ({{ timezone }})</div> -->
              <div class="t-cell col-6 col-lg-3 fs-14 text-dark-grey">{{ archive.create_time | utcCalcAccount | async }}</div>
              <!-- <div class="t-cell sm-show col-6">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.SIZE' | translate }}</div> -->
              <div class="t-cell col-6 col-lg-2 text-lg-center fs-14 text-dark-grey">{{ (archive.size ? archive.size : 0) | fileSize }}</div>
              <!-- <div class="t-cell sm-show col-6">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.STORAGE' | translate }}</div> -->
              @if (!webdavEnabled) {
                <div class="t-cell col-6 col-lg-2 text-lg-center fs-14 text-dark-grey">
                  @if (archive.storage_shared === true) {
                    <img style="width: 20px; height: 20px; object-fit: contain;" [src]="('design' | env).squareLogo">
                  }
                  @if (archive.storage_shared === false) {
                    <img style="width: 20px; height: 20px; object-fit: contain;" src="assets/img/azure_blue.png">
                  }
                </div>
              }
              @if (webdavEnabled) {
                <div class="t-cell col-6 col-lg-2 text-lg-center">
                  <div class="fs-14 text-dark-grey font-weight-700" style="font-size: 12px;">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.WEBDAV' | translate }}</div>
                </div>
              }
              <!-- <div class="t-cell sm-show col-6">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.STATUS' | translate }}</div> -->
              <div class="t-cell col-6 col-lg-2 fs-14 font-weight-600 text-dark-grey"><span>{{ getArchiveStatusKey(archive) | translate }}</span></div>
              <div class="t-cell col-12 col-lg-3 d-flex justify-content-lg-end">
                @if (!webdavEnabled && archive.storage_status === 'uploaded') {
                  <div class="btn-group d-flex justify-content-center justify-content-lg-end">
                    <button type="button" class="btn btn-sm btn-warning" (click)="onWatchArchive(archive)">
                      <i class="mi mi-play-arrow"></i><span class="d-inline d-lg-none">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.PLAY' | translate }}</span>
                    </button>
                    <!--
                    <button type="button" class="btn btn-sm btn-info" (click)="onDownloadArchive(archive)">
                      <i class="mi mi-cloud-download" style="font-size: 16px;"></i><span class="d-inline d-lg-none">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.DOWNLOAD' | translate }}</span>
                    </button>
                    -->
                    <div class="dropdown-items" dropdown>
                      <button [id]="'dropdown-button-'+1" (click)="onDownloadArchive(archive)" dropdownToggle type="button" class="btn btn-sm btn-info dropdown-toggle" [attr.aria-controls]="'dropdown-'+1">
                        <i class="mi mi-cloud-download"></i><span class="d-inline d-lg-none">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.DOWNLOAD' | translate }}</span>
                      </button>
                      <ul [id]="'dropdown-'+1" *dropdownMenu class="dropdown-ul dropdown-menu p-1" role="menu" [attr.aria-labelledby]="'dropdown-button-'+1">
                        <li role="menuitem">
                          @if (downloadLinks[archive.id]?.loading) {
                            <a class="dropdown-item">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.GENERATING' | translate }}</a>
                          }
                          @if (downloadLinks[archive.id]?.url) {
                            <a class="dropdown-item" [href]="$safeNavigationMigration(downloadLinks[archive.id]?.url)" download="record.mp4" target="_blank">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.DOWNLOAD' | translate }}</a>
                          }
                        </li>
                      </ul>
                    </div>
                    @if (canTranscribeArchive(archive)) {
                      <button type="button" class="btn btn-sm btn-secondary transcript-btn" [disabled]="isTranscriptionBusy(archive)" [title]="getTranscriptionButtonTitle(archive)" (click)="onTranscriptionAction(archive)">
                        @if (isTranscriptionBusy(archive)) {
                          <span class="spinner-border spinner-border-sm"></span>
                        }
                        @if (!isTranscriptionBusy(archive)) {
                          <i class="mi" [ngClass]="transcriptionViews[archive.id]?.status === 'done' ? 'mi-description' : 'mi-subtitles'"></i>
                          }<span class="d-inline d-lg-none ms-1">{{ getTranscriptionButtonLabel(archive) | translate }}</span>
                        </button>
                      }
                      <button type="button" class="btn btn-sm btn-danger" (click)="onDeleteArchive(archive)">
                        <i class="mi mi-delete"></i><span class="d-inline d-lg-none">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.DELETE' | translate }}</span>
                      </button>
                    </div>
                  }
                  @if (transcriptionViews[archive.id]?.status === 'failed') {
                    <div class="archive-transcription-error mt-2">
                      {{ transcriptionViews[archive.id]?.error || ('MAIN.ARCHIVES.ARCHIVE_LIST.TRANSCRIPTION_FAILED' | translate) }}
                    </div>
                  }
                  <!--<a class="btn btn-sm btn-info py-0 text-white" style="cursor: pointer; font-size: 11px;" *ngIf="archive.storage_status === 'uploaded'" (click)="onDownloadArchive(archive)">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.DOWNLOAD' | translate }}</a>-->
                </div>
              </div>
            }
          </div>
        } @else {
          <div class="bg-white empty-list">
            <div class="fs-14 text-dark-grey"> {{ 'MAIN.ARCHIVES.ARCHIVE_LIST.NO_ARCHIVE_MESSAGE' | translate }}</div>
          </div>
        }
      } @else {
        <div class="bg-white empty-list">
          <div class="fs-14 text-dark-grey">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.LOADING' | translate }}</div>
        </div>
      }
    </div><!--card-body-->
  </div><!--card-->



  <!--
  <ng-template #downloadArchiveTemplate let-dataModel="dataModel" let-callbacks="callbacks">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="card">
          <div class="card-header py-3">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.DOWNLOAD_ARCHIVE.TITLE' | translate }}</div>
          <div class="card-body">
            <div class="m-body padded">
              <p *ngIf="!dataModel.failed && !dataModel.succeeded" class="font-weight-bold text-secondary">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.DOWNLOAD_ARCHIVE.GENERATING' | translate }}</p>
              <p *ngIf="dataModel.succeeded" class="font-weight-bold text-success">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.DOWNLOAD_ARCHIVE.GENERATED' | translate }}</p>
              <p *ngIf="dataModel.failed" class="font-weight-bold text-danger">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.DOWNLOAD_ARCHIVE.CANNOT_GENERATED' | translate }}</p>
            </div>
            <div class="m-footer">
              <ng-container *ngIf="!dataModel.failed">
                <a class="text-secondary" (click)="callbacks.cancel()">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.DOWNLOAD_ARCHIVE.CANCEL' | translate }}</a>
                <a *ngIf="dataModel.succeeded" class="text-info text-decoration-none" [href]="dataModel.url" download="filename.mp4">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.DOWNLOAD_ARCHIVE.DOWNLOAD' | translate }}</a>
              </ng-container>
              <a *ngIf="dataModel.failed" class="text-secondary" (click)="callbacks.cancel()">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.DOWNLOAD_ARCHIVE.CLOSE' | translate }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  -->

  <ng-template #watchArchiveTemplate let-dataModel="dataModel" let-callbacks="callbacks">
    <div class="modal-dialog-wide modal-dialog" role="document">
      <div class="modal-content">
        <div class="card">
          <div class="card-header py-3">{{ selectedArchive.create_time | utcCalcAccount | async }} {{ timezone }}</div>
          <div class="card-body">
            <div class="m-body">
              @if (dwUrl) {
                <div>
                  <video class="azuremediaplayer amp-default-skin" controls data-setup='{"techOrder": ["azureHtml5JS", "flashSS", "html5FairPlayHLS","silverlightSS", "html5"], "nativeControlsForTouch": false}'>
                    <source [src]="dwUrl" type="video/mp4"/>
                  </video>
                </div>
              }
              @if (!dwUrl) {
                <div>
                  <p>{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.PLEASE_WAIT' | translate }}</p>
                </div>
              }
              <div class="d-flex justify-content-end">
                @if (selectedArchive) {
                  <a class="btn btn-outline-success mt-2" style="height: 38px;" [href]="dwUrl" download="filename.mp4">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.DOWNLOAD_ARCHIVE.DOWNLOAD' | translate }}</a>
                }
                <button class="btn btn-outline-dark m-2" (click)="callbacks.close()">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.DOWNLOAD_ARCHIVE.CLOSE' | translate }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #transcriptTemplate let-dataModel="dataModel" let-callbacks="callbacks">
    <div class="modal-dialog-transcript modal-dialog" role="document">
      <div class="modal-content">
        <div class="card transcript-card">
          <div class="card-header py-3 d-flex justify-content-between align-items-center transcript-header">
            <div>
              <div class="transcript-title">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.TRANSCRIPTION' | translate }}</div>
              @if (selectedArchive) {
                <div class="transcript-subtitle">{{ selectedArchive.create_time | utcCalcAccount | async }} {{ timezone }}</div>
              }
            </div>
            <button class="btn btn-outline-dark btn-sm" (click)="callbacks.close()">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.DOWNLOAD_ARCHIVE.CLOSE' | translate }}</button>
          </div>
          <div class="card-body">
            @if (selectedTranscript) {
              <div class="transcript-meta-grid">
                <div class="transcript-meta-card">
                  <div class="transcript-meta-label">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.LANGUAGE' | translate }}</div>
                  <div class="transcript-meta-value">{{ selectedTranscript.language || '-' }}</div>
                </div>
                <div class="transcript-meta-card">
                  <div class="transcript-meta-label">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.SPEAKERS' | translate }}</div>
                  <div class="transcript-meta-value">{{ selectedTranscript.speakerCount || 0 }}</div>
                </div>
                <div class="transcript-meta-card">
                  <div class="transcript-meta-label">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.SEGMENTS' | translate }}</div>
                  <div class="transcript-meta-value">{{ selectedTranscript.segmentCount || 0 }}</div>
                </div>
                <div class="transcript-meta-card">
                  <div class="transcript-meta-label">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.DURATION' | translate }}</div>
                  <div class="transcript-meta-value">{{ formatSeconds(selectedTranscript.durationSec) }}</div>
                </div>
              </div>
            }
            @if (selectedTranscript?.transcript?.segments?.length) {
              <div class="transcript-layout">
                <div class="transcript-list">
                  @for (segment of selectedTranscript.transcript.segments; track segment) {
                    <div class="transcript-segment">
                      <div class="transcript-segment-header">
                        <span class="transcript-time">{{ formatSeconds(segment.startSec) }} - {{ formatSeconds(segment.endSec) }}</span>
                        @if (segment.speakerLabel) {
                          <span class="transcript-speaker">{{ segment.speakerLabel }}</span>
                        }
                      </div>
                      <div class="transcript-text">{{ segment.text }}</div>
                    </div>
                  }
                </div>
                <div class="transcript-copy-panel">
                  <div class="transcript-copy-header">
                    <span>{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.FULL_TEXT' | translate }}</span>
                    <button type="button" class="btn btn-sm transcript-copy-button" [copy-clipboard]="getTranscriptPlainText()" [select-text]="transcriptCopyArea" (copied)="onTranscriptCopied()" title="Copy" aria-label="Copy transcript text">
                      <i class="mi mi-content-copy"></i>
                    </button>
                  </div>
                  <textarea #transcriptCopyArea class="transcript-copy-textarea" [value]="getTranscriptPlainText()" readonly spellcheck="false"></textarea>
                </div>
              </div>
            } @else {
              <div class="transcript-empty-state">
                <div class="transcript-empty-icon">Aa</div>
                <div class="transcript-empty-title">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.NO_TRANSCRIPT' | translate }}</div>
                <div class="transcript-empty-caption">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.NO_TRANSCRIPT_HINT' | translate }}</div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #deleteArchiveTemplate let-dataModel="dataModel" let-callbacks="callbacks">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="card">
          <div class="card-header py-3">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.DELETE_ARCHIVE.TITLE' | translate }}</div>
          <div class="card-body">
            <div class="m-body padded">
              <p class="text-secondary">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.DELETE_ARCHIVE.MESSAGE' | translate }}</p>
              @if (!dataModel.shared) {
                <p class="font-weight-bold text-danger mt-2">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.DELETE_ARCHIVE.CAUTION' | translate }}</p>
              }
            </div>
            <div class="m-footer">
              <a class="text-info" (click)="callbacks.cancel()">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.DELETE_ARCHIVE.CANCEL' | translate }}</a>
              <a class="text-danger" (click)="callbacks.delete()">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.DELETE_ARCHIVE.DELETE' | translate }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>